import axios from "axios";
import React from "react";
import { useState } from "react";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";

import Button from "@mui/material/Button";
import LoadingButton from "@mui/lab/LoadingButton";

import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import CloseIcon from "@mui/icons-material/Close";

import GetCSRFToken from "./GetCSRFToken";

type LogoutDialogProps = {
  open: boolean;
  close: () => void;
  propagateLogout: () => void;
};

function LogoutDialog(props: LogoutDialogProps) {
  const [loading, setLoading] = useState(false);

  const [success, setSuccess] = useState(false);

  function handleCancel() {
    setLoading(false);
    props.close();
  }

  return (
    <Dialog open={props.open} onClose={handleCancel} disableRestoreFocus>
      <DialogTitle> Log out? </DialogTitle>
      <DialogActions sx={{ justifyContent: "space-between" }}>
        <LoadingButton
          loading={loading}
          startIcon={<LogoutOutlinedIcon />}
          onClick={() => {
            setLoading(true);
            axios
              .get("/api/user/logout", {
                headers: { "X-CSRFToken": GetCSRFToken() },
              })
              .then((res) => {
                props.propagateLogout();
                setSuccess(true);
                handleCancel();
                setTimeout(() => setSuccess(false), 1000); // clear the successful signout state 1 second logout
                // TODO: something with this response, a successful logout?
                // TODO: propogate upward to force a reload and kill / hide al lthe data
                // TODO: force this to log out across multiple tabs too
                // TODO: flash a success message?
              })
              .catch((err) => {
                if (process.env.NODE_ENV === "development") {
                  console.log(err);
                } // TODO: handle failed log out
                setLoading(false);
              });
          }}
        >
          {success ? "Logged out" : "Log Out"}
        </LoadingButton>
        <Button variant="contained" color="error" startIcon={<CloseIcon />} onClick={handleCancel} autoFocus>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default LogoutDialog;
